import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../Tabels/Tabels.css";
import Header from "../Header/Header";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

import Users from "./Users";
import Reports from "./Reports";
import { createExporters } from "../../../utils/exportHelpers";
import { formatDate, IDS } from "../../../utils/common";
// import { Context } from "../../../utils/context";
import { getSetup } from "../../../utils/apis/masters/masters";
import { Permission } from "../../../utils/permissions";
library.add(fas);

// *****************************************************************************************************

const Tables = () => {
  const [setup, setSetup] = useState({});
  const getsetup = async () => {
    const res = await getSetup();
    await setSetup(res?.data);
  };

  useEffect(() => {
    getsetup();
  }, []);
  const convertrate = (amount) => {
    const inr = Number(amount);
    const rate = Number(setup?.withdraw_exchange_rate || 0);
    const total = (inr * rate).toFixed(2);
    return total;
  };

  // hok form

  // table
  const { isAllow } = useContext(Context);

  const [status, setStatus] = useState();

  const investorName = (d) =>
    `${d?.user?.f_name || ""} ${d?.user?.l_name || ""}`.trim();

  const withdrawStatus = (d) =>
    d?.accepted_rejected === null
      ? ""
      : d?.accepted_rejected
        ? "Accepted"
        : "Rejected";

  const col = {
    id: { name: "ID", value: (d) => d.id },
    date: { name: "Payment Date", value: (d) => formatDate(d.createdAt) },
    investor: { name: "Investor Name", value: investorName },
    serviceNo: { name: "Service No", value: (d) => d?.user?.contact_no },
    state: { name: "State", value: (d) => d?.user?.users_detail?.state?.name },
    district: { name: "District", value: (d) => d?.user?.users_detail?.city?.name },
    acNo: {
      name: "A/C No",
      value: (d) => d?.ac_no,
      // keep long account numbers as text in Excel
      excel: (d) => "'" + d?.ac_no?.toString() + "'",
    },
    ifsc: { name: "IFSC Code", value: (d) => d?.ifsc_code },
    amountUsd: { name: "Withdrawal Amount USD", value: (d) => d?.amount },
    amountInr: {
      name: "Withdrawal Amount Rupees",
      value: (d) => convertrate(Number(d?.amount)),
    },
    chargesUsd: { name: "Bank Charges USD", value: (d) => d?.bank_charges },
    chargesInr: {
      name: "Bank Charges Rupees",
      value: (d) => convertrate(d?.bank_charges),
    },
    paymentType: { name: "Payment Type", value: (d) => d?.withdrawn_type },
  };

  // Users table: pending withdrawals
  const userColumns = [
    col.id,
    col.date,
    col.investor,
    col.serviceNo,
    col.state,
    col.district,
    col.acNo,
    col.ifsc,
    col.amountUsd,
    col.amountInr,
    col.chargesUsd,
    col.chargesInr,
    col.paymentType,
  ];

  // Report table: processed withdrawals, with their final status
  const reportColumns = [
    col.id,
    col.date,
    col.investor,
    col.serviceNo,
    col.state,
    col.district,
    col.acNo,
    col.ifsc,
    col.amountUsd,
    col.amountInr,
    col.chargesUsd,
    col.chargesInr,
    { name: "Status", value: withdrawStatus },
    {
      name: "Customer Cancel Status",
      value: (d) => IDS.customer_status[d?.customer_status],
    },
    col.paymentType,
  ];

  // Users and Report each export exactly the columns shown in their own table
  const userExport = createExporters(userColumns);
  const reportExport = createExporters(reportColumns);



  //



  // const onSubmit = async (data) => {
  //   // alert(JSON.stringify(data));

  //   const formData = new FormData();
  //   formData.append("file", data.excel[0]);

  //   const res = await AcceptBulkCanceled(formData);
  //   if (res.success) {
  //     alert("Accept Bulk Outword SuccessFull...!");
  //     navigate("/outward");
  //     reset();
  //   } else {
  //     alert("Something went wrong...!");
  //   }
  // };
  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Canceled Payment"} link={"/outward"} />

        {/* <div className="card-body p-3">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row align-items-end">
             
              <div className="col-md-6">
                <div className="form-group">
                  <label>Upload Excel Sheet</label>
                  <input
                    type="file"
                    className="form-control"
                    accept=".xls,.xlsx"
                    {...register("excel", {
                      required: "Excel file is required",
                    })}
                  />
                  {errors.excel && (
                    <small className="text-danger">
                      {errors.excel.message}
                    </small>
                  )}
                </div>
              </div>

              <div className="col-md-3">
                <label className="d-block">&nbsp;</label>
               
                <button
                  onClick={DownloadSample}
                  type="button"
                  // variant="danger"
                  className="btn btn-outline-primary w-100"
                >
                  Download Sample Sheet
                </button>
              </div>

              <div className="col-md-3">
                <label className="d-block">&nbsp;</label>
                <button type="submit" className="btn btn-success w-100">
                  Upload
                </button>
              </div>
            </div>
          </form>
        </div> */}

        {/* <div className="investor-main"><div></div>
          <div className="filterdiv mt-4 me-3">
            <button onClick={() => setModalShow2(true)} className="filterbtn">
              <FontAwesomeIcon icon={faFilter} />
              &nbsp;Filter
            </button>
          </div>
        </div> */}

        {isAllow?.includes(Permission.OutwardPayment.UsersList.name) ? (
          <Users
            isAllow={isAllow}
            status={status}
            setStatus={setStatus}
            handleExportCSV={userExport.csv}
            handlePrint={userExport.print}
            handleExportExcel={userExport.excel}
            convertrate={convertrate}
          />
        ) : (
          <></>
        )}

        {isAllow?.includes(Permission.OutwardPayment.ReportList.name) ? (
          <Reports
            isAllow={isAllow}
            status={status}
            setStatus={setStatus}
            handleExportCSV={reportExport.csv}
            handlePrint={reportExport.print}
            handleExportExcel={reportExport.excel}
            convertrate={convertrate}
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default Tables;
